/* eslint-disable class-methods-use-this */
import axios from 'axios';
import { getAuthToken } from './auth.service';

const headers = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'PATCH',
  'Content-Type': 'application/json',
};

class PatchHelper {
  async patch(url: string, data: any) {
    const response = await axios
      .patch(url, data, { headers });
    return response;
  }
}
export default new PatchHelper();
